import { Authentication } from '@coldandgoji/svelte-firebase'
import { log } from '@coldandgoji/utilities'

const initialize = async () => {
  log( '@core/initialize', 'initialize' )

  return true
}

const uninitialize = () => {
  log( '@core/initialize', 'uninitialize' )

  // Sign out
  Authentication.signOut()
}

export {
  initialize,
  uninitialize,
}
